import { Box } from '@sequencehq/core-components'
import { PreviewContainer } from '../components'

export const CustomerPortalPreview = () => {
  return (
    <PreviewContainer>
      <Box width="576px">Customer Portal Preview</Box>
    </PreviewContainer>
  )
}
